import flatpickr from 'flatpickr'

document.addEventListener('turbo:load', () => {
  document.querySelectorAll('.flatpickr-select').forEach((input) => {
    flatpickr(input, {
      altInput: true,
      altFormat: 'd/m/Y',
      dateFormat: 'Y-m-d',
      allowInput: true,
      maxDate: 'today',
      onReady: (selectedDates, dateStr, instance) => {
        const todayButton = document.createElement('button')
        todayButton.type = 'button'
        todayButton.className = 'btn btn-sm btn-outline-secondary d-block w-100'
        todayButton.textContent = input.dataset.todayLabel || 'Today'

        todayButton.addEventListener('click', () => {
          instance.setDate(new Date(), true)
          instance.close()
        })

        instance.calendarContainer.appendChild(todayButton)
      }
    })
  })
})
